import { StyleSheet } from 'lib/paypalphrodite'
import * as media from '../../../lib/styles/media-queries'

export default StyleSheet.create({
  wrapper: {
    background: 'white',
    marginBottom: 15,
    padding: 20,
    border: '1px solid #f2f2f2',
    [media.smallAndSmaller]: {
      padding: 24,
    },
  },
  headerText: {
    textAlign: 'left',
    fontWeight: 600,
    color: '#2C2E2F',
    fontSize: 15,
    ':hover': {
      cursor: 'pointer',
    },
    ':focus': {
      outline: 'none',
    },
  },
  chevronIcon: {
    float: 'right',
    lineHeight: 0.75,
  },
  optionsWrapper: {
    boxSizing: 'border-box',
    height: 101,
    width: 432,
    border: '1px solid #BFDBEE',
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
    padding: 20,
    margin: '15px 10px 10px 0px',
    '@media (max-width: 450px)': {
      margin: '20px 0 16px',
      maxWidth: 325,
    },
    display: 'flex',
    ':hover': {
      cursor: 'pointer',
    },
    ':focus': {
      outline: 'none',
    },
  },
  optionHeader: {
    height: 24,
    width: 316,
    color: '#2C2E2F',
    padding: 35,
    fontSize: 15,
    fontWeight: 600,
    [media.mediumAndSmaller]: {
      padding: 20,
    },
  },
  optionDetail: {
    height: 36,
    color: '#687173',
    display: 'block',
    fontSize: 13,
    padding: '10px 0 0 35px',
    [media.mediumAndSmaller]: {
      padding: '10px 0 0 20px',
    },
  },
  selectedOption: {
    backgroundColor: '#E4F1FB',
  },
  ovalIcon: {
    boxSizing: 'border-box',
    height: 49,
    width: 49,
    border: '1px solid #0070BA',
    backgroundColor: '#FFFFFF',
    borderRadius: 60,
    padding: 1,
    color: '#0070BA',
    fontSize: 36,
    lineHeight: 1,
  },
  checkIcon: {
    padding: 6,
  },
})
